module.exports = __webpack_public_path__ + "static/media/tool.a9c97ffd.jpg";